export const isPoly = (rank?: string) => {
  if (!rank) {
    return false
  }

  return rank.includes('PolyM')
}
